import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export namespace NCmsHtml {
    export interface IComponentData extends NICmsContentComponent.IData {
        text: string;
    }
}

@ICmsComponent<CmsHtmlComponent>({
    id: 'html',
    name: 'Free HTML',
    tags: ['text', 'html'],
    isAdvanced: true,
    fields: [
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        {
            key: 'text',
            type: NICmsContentField.EFieldType.textarea,
            title: 'Copy with HTML tags allowed',
            default: 'Lorem ipsum dolor',
            required: true
        }
    ],
    priority: 50
})
@Component({
    selector: 'cms-html',
    templateUrl: './cms-html.html',
    imports: [ICmsClientModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsHtmlComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsHtml.IComponentData;
}
